"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _router = require("@reach/router");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _CmsHeader = _interopRequireDefault(require("./CmsHeader"));

var _PostForm = _interopRequireDefault(require("./PostForm"));

var _utils = require("../utils");

var _theme = require("../theme");

var _store = require("../store");

var _routes = _interopRequireDefault(require("../routes"));

var _templateObject, _templateObject2, _templateObject3;

var Logo = function Logo(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M27 27C15.785 27 7 21.688 7 14.905v-2.807C7 5.316 15.785 0 27.002 0 38.215 0 47 5.314 47 12.098v2.807c.002 3.433-2.22 6.584-6.257 8.858C37.04 25.85 32.159 27 27 27zm.002-23.31c-9.797 0-16.379 4.349-16.379 8.41v2.806c0 4.062 6.58 8.409 16.377 8.409 4.555 0 8.81-.984 11.984-2.773 2.793-1.574 4.395-3.63 4.393-5.633V12.1c0-4.063-6.58-8.41-16.375-8.41z",
    fill: "#003A42",
    fillRule: "nonzero"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M32 31v2h11v13h-6v3H27v-3h-1V33h1v-2h5z",
    fill: "#7379FF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.051 36c-.8 0-1.607-.134-2.407-.448-1.386-.542-2.228-1.446-2.903-2.173-.38-.409-.71-.762-1.09-1.025-.481-.336-2.05.109-3.085.406-.743.21-1.514.432-2.236.525-4.696.6-6.633-1.127-7.432-2.676-2.202-4.274.224-7.04 1.14-8.08l.218-.254c.773-.963 3.893-3.723 4.508-4.268a1.925 1.925 0 0 1 2.598.08c.695.697.653 1.79-.085 2.444-1.44 1.265-3.659 3.29-4.085 3.822l-.322.376c-.82.933-1.841 2.095-.667 4.372.392.758 1.608 1.021 3.633.76.493-.063 1.06-.236 1.66-.407 1.847-.527 4.376-1.255 6.34.124.698.481 1.213 1.037 1.67 1.525.534.573.956 1.028 1.548 1.26 1.896.748 4.618-.975 6.606-2.224l.582-.365c3.718-2.3 6.259-.238 8.115 1.269.398.324.81.658 1.25.97.463.329.926.43 1.306.298.374-.131.646-.47.747-.927l.06-.277c.554-2.492 1.128-5.07 3.338-5.923.964-.37 1.924-.373 2.774-.373.417-.002 1.111-.002 1.276-.104 0 0 .06-.07.12-.285.669-2.423-2.579-4.392-2.612-4.412a1.667 1.667 0 0 1-.212-.144l-1.037-.815c-.777-.612-.88-1.701-.23-2.434.654-.73 1.814-.826 2.588-.216l.95.748c.846.528 5.361 3.6 4.106 8.147-.828 2.962-3.506 2.966-4.945 2.969-.537 0-1.092 0-1.387.114-.441.315-.891 2.344-1.135 3.433l-.06.279a4.73 4.73 0 0 1-3.049 3.452c-1.574.56-3.324.274-4.803-.766-.51-.359-.988-.746-1.449-1.12-1.952-1.584-2.403-1.799-3.692-.998l-.562.351C25.716 34.258 22.938 36 20.05 36z",
    fill: "#003A42",
    fillRule: "nonzero"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.979 60C15.896 60 8 55.395 8 49.51V30.108c0-1.005.82-1.821 1.83-1.821 1.012 0 1.832.816 1.832 1.821v19.404c0 3.238 5.88 6.846 14.317 6.846 8.718 0 14.36-3.794 14.36-5.105v-25.43c0-1.006.82-1.822 1.83-1.822 1.01 0 1.831.816 1.831 1.822v25.43C44 55.832 35.41 60 25.979 60z",
    fill: "#003A42",
    fillRule: "nonzero"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.602 52c-.55 0-.88-.027-.944-.032-.941-.086-1.658-.837-1.658-1.735v-17.49c0-.962.82-1.743 1.83-1.743 1.01 0 1.83.78 1.83 1.743V48.47c2.521-.183 7.53-1.084 12.297-5.101.756-.635 1.912-.571 2.583.15.67.72.6 1.822-.156 2.459C35.882 51.453 29.062 52 26.602 52zM25.484 19c-5.225 0-9.145-1.85-9.387-1.968-.9-.437-1.333-1.651-.967-2.724.368-1.073 1.397-1.587 2.297-1.156.079.036 7.653 3.566 15.179.167.907-.416 1.933.13 2.277 1.209.349 1.08-.109 2.29-1.019 2.7-2.922 1.324-5.81 1.772-8.38 1.772z",
    fill: "#003A42",
    fillRule: "nonzero"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M63.085 25.625c1.26 0 1.26 0 2.115.495.855.495.855.495.855 1.305V48.44l-.006.446c-.064 2.205-.064 2.205-.759 3.964-.765 1.935-.765 1.935-2.273 3.015-1.507 1.08-1.507 1.08-3.757 1.08-1.8 0-1.8 0-2.407-.742-.608-.743-.608-.743-.608-1.643 0-1.17 0-1.17.653-1.845.652-.675.652-.675 1.552-.675.81 0 .81 0 1.192-.45.383-.45.383-.45.495-1.283.113-.832.113-.832.113-1.867V27.425l.008-.159c.073-.7.073-.7.802-1.146.81-.495.81-.495 2.025-.495zm14.756-.27c3.51 0 3.51 0 5.625 1.26s2.115 1.26 3.082 3.24c.968 1.98.968 1.98.968 4.275v11.025l-.008.15c-.073.669-.073.669-.802 1.155-.81.54-.81.54-2.025.54-1.125 0-1.125 0-1.868-.54-.742-.54-.742-.54-.742-1.305V43.85l-.31.344c-1.11 1.186-1.11 1.186-2.548 2.131-1.642 1.08-1.642 1.08-3.982 1.08-2.385 0-2.385 0-4.118-1.462-1.732-1.463-1.732-1.463-1.732-4.523 0-2.565 0-2.565 1.327-4.005 1.328-1.44 1.328-1.44 3.69-2.025 2.363-.585 2.363-.585 5.468-.585h1.845v-.585l-.008-.282c-.047-.843-.047-.843-.375-1.653-.382-.945-.382-.945-1.215-1.575-.832-.63-.832-.63-2.362-.63-1.71 0-1.71 0-2.633.338-.922.337-.922.337-1.417.697-.495.36-.495.36-1.08.36-.945 0-.945 0-1.463-.945-.517-.945-.517-.945-.517-1.935 0-.945 0-.945 1.147-1.688 1.148-.742 1.148-.742 2.813-1.147 1.665-.405 1.665-.405 3.24-.405zm37.858 0c2.07 0 2.07 0 3.892 1.058 1.823 1.057 1.823 1.057 2.97 3.104 1.148 2.048 1.148 2.048 1.148 4.973v10.665l-.009.134c-.077.6-.077.6-.846 1.126-.855.585-.855.585-2.07.585-1.17 0-1.17 0-2.025-.585s-.855-.585-.855-1.26V34.49l-.006-.294c-.052-1.156-.052-1.156-.512-1.956-.517-.9-.517-.9-1.372-1.373-.855-.472-.855-.472-1.755-.472-.9 0-.9 0-1.688.473-.787.472-.787.472-1.327 1.372-.54.9-.54.9-.54 2.205V45.2l-.006.154c-.071.827-.071.827-.917 1.218-.922.428-.922.428-2.002.428-.99 0-.99 0-1.935-.428-.945-.427-.945-.427-.945-1.372V34.49l-.006-.276c-.052-1.084-.052-1.084-.512-1.884-.517-.9-.517-.9-1.35-1.395-.832-.495-.832-.495-1.777-.495-.9 0-.9 0-1.71.45-.81.45-.81.45-1.328 1.35-.517.9-.517.9-.517 2.25v10.665l-.009.134c-.077.6-.077.6-.846 1.126-.855.585-.855.585-2.07.585-1.26 0-1.26 0-2.07-.585-.81-.585-.81-.585-.81-1.26v-17.73l.008-.159c.073-.7.073-.7.802-1.146.81-.495.81-.495 2.07-.495 1.08 0 1.08 0 1.822.495.743.495.743.495.743 1.305v1.35l.16-.259c.753-1.152.753-1.152 2.09-2.103 1.485-1.058 1.485-1.058 3.735-1.058 1.935 0 1.935 0 3.42 1.26 1.485 1.26 1.485 1.26 2.205 3.24 1.17-2.295 1.17-2.295 2.992-3.398 1.823-1.102 1.823-1.102 3.758-1.102zM81.71 37.82h-.675l-.589.007c-1.166.029-1.166.029-2.246.173-1.35.18-1.35.18-2.183.788-.832.607-.832.607-.832 1.867s0 1.26.697 1.845c.698.585.698.585 1.688.585.945 0 .945 0 1.89-.63s.945-.63 1.597-1.62c.653-.99.653-.99.653-2.07v-.945zM63.13 15.185c1.35 0 1.35 0 2.25.832.9.833.9.833.9 2.003 0 1.08 0 1.08-.9 1.957-.9.878-.9.878-2.25.878-1.305 0-1.305 0-2.25-.878-.945-.877-.945-.877-.945-1.957 0-1.17 0-1.17.945-2.003.945-.832.945-.832 2.25-.832z",
    fill: "#555BD6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M195.228 13.88c1.035 0 1.035 0 2.452.157 1.418.158 1.418.158 2.835.563 1.418.405 1.418.405 2.34 1.103.923.697.923.697.923 1.777 0 .54 0 .54-.248 1.26-.247.72-.247.72-.765 1.283-.517.562-.517.562-1.327.562-.72 0-.72 0-1.418-.428-.697-.427-.697-.427-1.8-.855-1.102-.427-1.102-.427-2.992-.427-1.575 0-1.575 0-2.745.427-1.17.428-1.17.428-1.755 1.17-.585.743-.585.743-.585 1.868 0 1.17 0 1.17.787 1.98.788.81.788.81 2.07 1.44 1.283.63 1.283.63 2.813 1.26 1.53.63 1.53.63 3.082 1.463 1.553.832 1.553.832 2.858 2.002 1.305 1.17 1.305 1.17 2.07 2.903.765 1.732.765 1.732.765 4.252 0 3.195 0 3.195-1.395 5.377-1.395 2.183-1.395 2.183-3.803 3.285-2.407 1.103-2.407 1.103-5.512 1.103-2.925 0-2.925 0-5.288-.855-2.362-.855-2.362-.855-3.735-2.137-1.372-1.283-1.372-1.283-1.372-2.588 0-.63 0-.63.337-1.373.338-.742.338-.742.923-1.26.585-.517.585-.517 1.305-.517s.72 0 1.35.518c.63.517.63.517 1.44 1.215.81.697.81.697 1.98 1.215 1.17.517 1.17.517 2.88.517 1.35 0 1.35 0 2.497-.428 1.148-.427 1.148-.427 1.845-1.282.698-.855.698-.855.698-2.205 0-1.44 0-1.44-.765-2.43-.765-.99-.765-.99-2.07-1.71-1.305-.72-1.305-.72-2.835-1.395s-1.53-.675-3.083-1.44c-1.552-.765-1.552-.765-2.835-1.845-1.282-1.08-1.282-1.08-2.07-2.655-.787-1.575-.787-1.575-.787-3.87 0-2.52 0-2.52.967-4.23.968-1.71.968-1.71 2.565-2.767 1.598-1.058 1.598-1.058 3.533-1.53 1.935-.473 1.935-.473 3.87-.473zm-56.448.225c3.15 0 3.15 0 5.558 1.057 2.407 1.058 2.407 1.058 3.78 2.948 1.372 1.89 1.372 1.89 1.372 4.545 0 1.755 0 1.755-.72 2.317-.72.563-.72.563-2.205.563-1.215 0-1.215 0-2.047-.427-.833-.428-.833-.428-.878-1.418 0-.54 0-.54-.157-1.283-.158-.742-.158-.742-.608-1.462-.45-.72-.45-.72-1.373-1.215-.922-.495-.922-.495-2.542-.495-2.295 0-2.295 0-3.532 1.282-1.238 1.283-1.238 1.283-1.238 3.893v12.555l.005.326c.074 2.408.074 2.408 1.255 3.589 1.26 1.26 1.26 1.26 3.6 1.26 1.53 0 1.53 0 2.43-.495.9-.495.9-.495 1.328-1.238.427-.742.427-.742.585-1.552.157-.81.157-.81.247-1.53.09-1.035.09-1.035.9-1.44s.81-.405 1.98-.405c1.53 0 1.53 0 2.25.585s.72.585.72 2.295c0 2.7 0 2.7-1.373 4.725-1.372 2.025-1.372 2.025-3.802 3.105-2.43 1.08-2.43 1.08-5.58 1.08-2.79 0-2.79 0-5.175-1.013-2.385-1.012-2.385-1.012-3.78-3.285-1.395-2.272-1.395-2.272-1.395-6.007V24.41l.005-.434c.077-3.435.077-3.435 1.39-5.573 1.395-2.273 1.395-2.273 3.78-3.285 2.385-1.013 2.385-1.013 5.22-1.013zm37.92 0c1.125 0 1.125 0 2.025.652.9.653.9.653.9 2.273v28.125l-.006.147c-.07.792-.07.792-.916 1.226-.923.472-.923.472-2.003.472s-1.08 0-2.002-.472c-.923-.473-.923-.473-.923-1.373v-19.35l-5.22 9.36-.118.173c-.364.496-.364.496-.827.727-.54.27-.54.27-1.08.27-.495 0-.495 0-1.012-.248-.518-.247-.518-.247-.923-.922l-5.175-9.72v19.71l-.006.147c-.069.792-.069.792-.894 1.226-.9.472-.9.472-2.025.472-1.08 0-1.08 0-2.002-.472-.923-.473-.923-.473-.923-1.373V17.03l.005-.226c.061-1.44.061-1.44.918-2.046.922-.653.922-.653 2.002-.653 1.08 0 1.08 0 1.823.225.742.225.742.225 1.395.9.652.675.652.675 1.372 1.98l5.49 10.08 5.535-10.08.178-.282c.7-1.098.7-1.098 1.24-1.698.607-.675.607-.675 1.372-.9.765-.225.765-.225 1.8-.225z",
    fill: "#003A42"
  })));
};

Logo.defaultProps = {
  viewBox: "0 0 205 60",
  xmlns: "http://www.w3.org/2000/svg"
};

var CmsLayout = function CmsLayout(props) {
  var _config$fields, _authUser$capabilitie, _authUser$capabilitie2;

  var pageTitle = props.pageTitle,
      children = props.children;

  var _ref2 = (0, _store.useStore)(),
      _ref3 = _slicedToArray(_ref2, 2),
      _ref3$ = _ref3[0],
      config = _ref3$.config,
      authUser = _ref3$.authState.authUser,
      _ref3$$cmsState = _ref3$.cmsState,
      siteID = _ref3$$cmsState.siteID,
      sites = _ref3$$cmsState.sites,
      dispatch = _ref3[1];

  var handleAddPost = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var postTypeID, title, parentID;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              postTypeID = _ref.postTypeID, title = _ref.title, parentID = _ref.parentID;
              _context.next = 3;
              return (0, _utils.addPost)({
                site: sites[siteID],
                postTypeID: postTypeID,
                title: title,
                parentID: parentID
              }, dispatch, config);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleAddPost(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactHelmet.default, null, /*#__PURE__*/_react.default.createElement("title", null, pageTitle || 'Not Found', " - jamCMS")), /*#__PURE__*/_react.default.createElement(_antd.Layout, {
    className: "jam-cms"
  }, /*#__PURE__*/_react.default.createElement(_antd.Layout.Sider, {
    className: "sider",
    theme: "dark",
    width: 250,
    style: {
      overflow: 'auto',
      height: '100vh',
      position: 'fixed',
      left: 0
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(SidebarHeader, {
    title: /*#__PURE__*/_react.default.createElement(LogoContainer, null, /*#__PURE__*/_react.default.createElement(Logo, null))
  }), /*#__PURE__*/_react.default.createElement(_antd.Menu, {
    theme: "dark",
    mode: "vertical",
    defaultSelectedKeys: [pageTitle]
  }, /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
    key: "Dashboard",
    icon: /*#__PURE__*/_react.default.createElement(_icons.PieChartOutlined, null)
  }, /*#__PURE__*/_react.default.createElement(_router.Link, {
    to: (0, _routes.default)("dashboard", {
      siteID: siteID
    })
  }, "Dashboard")), /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
    key: "Media",
    icon: /*#__PURE__*/_react.default.createElement(_icons.FolderOpenOutlined, null)
  }, /*#__PURE__*/_react.default.createElement(_router.Link, {
    to: (0, _routes.default)("media", {
      siteID: siteID
    })
  }, "Media")), /*#__PURE__*/_react.default.createElement(_antd.Menu.SubMenu, {
    key: 'Collections',
    icon: /*#__PURE__*/_react.default.createElement(_icons.BlockOutlined, null),
    title: "Collections",
    popupOffset: [1, -4],
    subMenuOpenDelay: 0,
    subMenuCloseDelay: 0
  }, (config === null || config === void 0 ? void 0 : (_config$fields = config.fields) === null || _config$fields === void 0 ? void 0 : _config$fields.postTypes) && Object.values(config.fields.postTypes).map(function (o, i) {
    var _config$fields2; // Render taxonomies per post type (they can be assigned to multiple post types)
    // We grab them from the fields object


    var postTypeTaxonomies = [];
    (config === null || config === void 0 ? void 0 : (_config$fields2 = config.fields) === null || _config$fields2 === void 0 ? void 0 : _config$fields2.taxonomies) && Object.values(config.fields.taxonomies).map(function (p) {
      return p.postTypes.includes(o.id) && postTypeTaxonomies.push(p);
    });
    return /*#__PURE__*/_react.default.createElement(_antd.Menu.SubMenu, {
      key: o.title,
      title: o.title,
      popupOffset: [1, -4]
    }, /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
      key: o.title
    }, /*#__PURE__*/_react.default.createElement(_router.Link, {
      to: (0, _routes.default)("collection", {
        siteID: siteID,
        postTypeID: o.id
      })
    }, "All")), /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
      key: "add-".concat(o.id),
      onClick: function onClick() {
        return dispatch({
          type: 'SET_DIALOG',
          payload: {
            open: true,
            title: "Add ".concat(o.title),
            component: /*#__PURE__*/_react.default.createElement(_PostForm.default, {
              onSubmit: handleAddPost,
              postTypeID: o.id
            })
          }
        });
      }
    }, "Add new"), postTypeTaxonomies && postTypeTaxonomies.map(function (p) {
      return /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
        key: p.title
      }, /*#__PURE__*/_react.default.createElement(_router.Link, {
        to: (0, _routes.default)("taxonomy", {
          siteID: siteID,
          taxonomyID: p.id
        })
      }, p.title));
    }), Object.values(sites[siteID].postTypes).length - 1 !== i && /*#__PURE__*/_react.default.createElement(_antd.Menu.Divider, null));
  })), (authUser === null || authUser === void 0 ? void 0 : (_authUser$capabilitie = authUser.capabilities) === null || _authUser$capabilitie === void 0 ? void 0 : _authUser$capabilitie.list_users) && /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
    key: "Users",
    icon: /*#__PURE__*/_react.default.createElement(_icons.UsergroupAddOutlined, null)
  }, /*#__PURE__*/_react.default.createElement(_router.Link, {
    to: (0, _routes.default)("users", {
      siteID: siteID
    })
  }, "Users")), (authUser === null || authUser === void 0 ? void 0 : (_authUser$capabilitie2 = authUser.capabilities) === null || _authUser$capabilitie2 === void 0 ? void 0 : _authUser$capabilitie2.manage_options) && /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
    key: "Settings",
    icon: /*#__PURE__*/_react.default.createElement(_icons.SettingOutlined, null)
  }, /*#__PURE__*/_react.default.createElement(_router.Link, {
    to: (0, _routes.default)("settings-general", {
      siteID: siteID
    })
  }, "Settings"))))), /*#__PURE__*/_react.default.createElement(_antd.Layout, {
    style: {
      marginLeft: 250
    }
  }, /*#__PURE__*/_react.default.createElement(_CmsHeader.default, {
    title: pageTitle
  }), /*#__PURE__*/_react.default.createElement(_antd.Layout.Content, null, /*#__PURE__*/_react.default.createElement(Content, null, children)))));
};

var SidebarHeader = (0, _styledComponents.default)(_antd.PageHeader)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  .ant-page-header-heading-left {\n    width: 100%;\n  }\n\n  .ant-page-header-heading-title {\n    width: 100%;\n    margin: 0;\n    text-align: center;\n    color: #fff;\n  }\n"])));

var LogoContainer = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  display: block;\n  padding: 20px;\n\n  svg {\n    width: 120px;\n    margin: 0 auto;\n\n    path {\n      fill: ", ";\n    }\n  }\n"])), _theme.colors.secondaryContrast);

var Content = _styledComponents.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  min-height: 100vh;\n  max-width: 1024px;\n  margin: 0 auto;\n  padding: 70px 40px 60px;\n"])));

var _default = CmsLayout;
exports.default = _default;